import { Box, Button, Stack, Typography, Skeleton, Chip } from '@mui/material';
import styles from './BestTrackFocus.module.css'
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { Link } from 'react-router-dom';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDown from '@mui/icons-material/TrendingDown';
import { useState } from 'react';
import PlayPauseTrackButton from '../../../utils/PlayPauseTrackButton';

var buttonStyle = {color: '#fff', p: 1, minWidth: '16px', borderRadius: '32px'}
var buttonsContainerStyle = {backgroundColor: '#000000D0', p: 1, m: 1, borderRadius: '32px', height: '32px', position: 'absolute', bottom: 0, pointerEvents: 'all'}
var rankChipStyle = {fontWeight: 900, fontSize: '1rem'}

interface BestTrackFocusHoverProps {
    rankings: any
}

const BestTrackFocusHover = ({rankings}:BestTrackFocusHoverProps) => {
    var [currentIndex, setCurrentIndex] = useState(0) 

    const showNextArtist = () => {
        if (currentIndex + 1 === rankings.length || currentIndex > rankings.length) {
            setCurrentIndex(0)
        } else {
            setCurrentIndex(currentIndex + 1)
        }
    }

    const showPreviousArtist = () => {
        if (currentIndex - 1 === -1 || currentIndex < 0) {
            setCurrentIndex(rankings.length - 1)
        } else {
            setCurrentIndex(currentIndex - 1)
        }
    }

    if(rankings.length < currentIndex) {
        setCurrentIndex(0)
    }


    return rankings.length > currentIndex 
    ? (
        <Box className={styles.trackItem}>
            <Stack className={styles.trackInfos} direction={'column'}>

                <Stack direction={'row'} alignItems={'center'} sx={{m: 1}}>
                    <Stack direction={'column'} sx={{backgroundColor: '#000000D0', borderRadius: '16px', p: 2, '& a' : { textDecoration: 'none'}, pointerEvents: 'all'}}>
                        <Stack direction={'row'}>
                            <Typography sx={{color: '#fff', fontWeight: 600 }}>{ rankings[currentIndex].track.apple_title }</Typography>
                            <Typography sx={{color: '#fff', fontWeight: 500, fontStyle: 'italic', ml:1 }}>{ !rankings[currentIndex]?.track?.album?.apple_is_single ? `(${rankings[currentIndex]?.track?.album?.apple_name})` : null  }</Typography>
                        </Stack>

                        <Typography sx={{color: '#fff', fontWeight: 300}}>{ rankings[currentIndex]?.track?.album?.apple_artist_name }</Typography>
                    </Stack>
                </Stack>
                
                <Stack spacing={1} direction={'row'} alignItems={'center'} sx={{p: 1, backgroundColor: '#000000D0',  m: 1, borderRadius: '32px', height: '32px', position: 'absolute', bottom: 0}}>
                    <Chip color={'secondary'} key={currentIndex} label={'#'+ (rankings[currentIndex].position)} sx={rankChipStyle}/>
                    <Typography sx={{display: {xs: 'none', md: 'flex', lg: 'flex'}}}>{ rankings[currentIndex].position_gain === 'new' ? '' : rankings[currentIndex].position_gain === '=' ? "=" : parseInt(rankings[currentIndex]?.position_gain?.replace('+','')) > 0 ? <TrendingUpIcon/> : <TrendingDown/> }</Typography>
                    <Typography textAlign={'left'} sx={{color: '#fff', fontWeight: 700, display: {xs: 'none', md: 'flex', lg: 'flex'}, pr: 2}}>{ rankings[currentIndex].position_gain}</Typography>
                </Stack>

                <Stack spacing={1} direction={'row'} alignItems={'center'} sx={{display: {xs: 'flex', md: 'none', lg: 'none'}, p: 1, backgroundColor: '#000000D0',  m: 1, borderRadius: '32px', height: '32px', position: 'absolute', bottom: 0, right: 0, pr: 2}}>
                    { rankings[currentIndex].position_gain === 'new' ? '' : rankings[currentIndex].position_gain === '=' ? "=" : parseInt(rankings[currentIndex]?.position_gain?.replace('+','')) > 0 ? <TrendingUpIcon/> : <TrendingDown/> }
                    <Typography textAlign={'left'} sx={{color: '#fff', fontWeight: 700}}>{ rankings[currentIndex].position_gain}</Typography>
                </Stack>

                <Stack direction={'row'} alignSelf={{xs: 'center'}} sx={buttonsContainerStyle}>
                    <Button onClick={() => showPreviousArtist()} sx={buttonStyle}><NavigateBeforeIcon /></Button>
                    <PlayPauseTrackButton apple_id={rankings[currentIndex].track.apple_id} />
                    <Button onClick={() => showNextArtist()} sx={buttonStyle} ><NavigateNextIcon /></Button>
                </Stack>

            </Stack>
            <Link to={`/track/${rankings[currentIndex].track._id}`}>
                <img 
                    alt={rankings[currentIndex].track.apple_artist_name} 
                    height='100%' 
                    width='100%'
                    src={rankings[currentIndex]?.track?.album?.apple_artwork_url.replace("{w}","1200").replace("{h}","1200")} 
                    className="image-cover" />
            </Link>
        </Box>
    )
    : <Skeleton />
}

export default BestTrackFocusHover